import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ApprovalListComponent } from './components/approval-list/approval-list.component';

const routes: Routes = [
  {
    path: "", component: ApprovalListComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IncubatorApprovalRoutingModule { }
